import _regeneratorRuntime from "/Users/joe/Projects/onthewall-v2-leeungno/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
var _marked = /*#__PURE__*/ _regeneratorRuntime().mark(rootSaga);
import { all, fork } from 'redux-saga/effects';
import globalSaga from './global';
import musicSaga from './music';
import chatSaga from './chat';
import exhibitionSaga from './exhibition';
import collectionSaga from './collection';
export default function rootSaga() { return _regeneratorRuntime().wrap(function rootSaga$(_context) { while (1)
    switch (_context.prev = _context.next) {
        case 0:
            _context.next = 2;
            return all([fork(globalSaga), fork(musicSaga), fork(chatSaga), fork(exhibitionSaga), fork(collectionSaga)]);
        case 2:
        case "end": return _context.stop();
    } }, _marked); }
